export default __webpack_public_path__ + "static/media/BSL.1028cb72.bin";